import { z } from "zod";

export type EnergyLabelMetadata = z.infer<
  typeof energyLabelResponseSchema
>["responseMetaData"];
export type EnergyLabelResults = z.infer<
  typeof energyLabelResponseSchema
>["results"];

export const energyLabelResponseSchema = z.object({
  status: z.object({
    code: z.number(),
    message: z.string(),
  }),
  responseMetaData: z.object({
    general: z.object({
      calculationData: z.object({
        annualCostPerKwhPercentageChange: z.string(),
        annualCostPerKwhPercentageChangeNumberOfYears: z.string(),
        tariffByYear: z
          .array(z.string().optional())
          .or(z.record(z.string(), z.string())),
      }),
      productTypes: z.array(z.string().optional()).or(
        z.record(
          z.string(),
          z.object({
            averageUsage: z.number().nullable(),
            averageUsagePeriod: z.number().nullable(),
            averageUsageTimesPerPeriod: z.number().nullable(),
            energyCostYears: z.number(),
          }),
        ),
      ),
      tariff: z.number(),
    }),
  }),
  results: z.record(
    z.string(),
    z.object({
      productFound: z.boolean(),
      manufacturer: z.string().optional(),
      sku: z.string().optional(),
      imageUrl: z.string().optional(),
      productType: z.string().optional(),
      hasEnergyData: z.boolean().optional(),
      energyCost: z.string().optional(),
      energyCostUnformatted: z.number().optional(),
      mostEfficientEnergyCost: z.string().optional(),
      mostEfficientEkoScore: z.number().optional(),
      leastEfficientEnergyCost: z.string().optional(),
      leastEfficientEkoScore: z.number().optional(),
      maximumSaving: z.string().optional(),
      ekoScore: z.number().optional(),
      price: z.string().optional(),
      priceUnformatted: z.number().optional(),
      isPriceFromPartner: z.boolean().optional(),
      ekoGroupValueText: z.string().optional(),
      ekoGroupValueRatingText: z.string().optional(),
      ekoGroupValueTextPlural: z.string().optional(),
      ekoGroupValueRatingTextPlural: z.string().optional(),
      comparedEnergyCostUnformatted: z.number().optional(),
      comparedEnergyCost: z.string().optional(),
      comparedEkoScore: z.number().optional(),
      energyCostSavingUnformatted: z.number().optional(),
      energyCostSaving: z.string().optional(),
      averageEnergyCost: z.string().optional(),
      averageEnergyCostUnformatted: z.number().optional(),
      averageEkoScore: z.number().optional(),
      averageEnergyCostSaving: z.string().optional(),
      averageEnergyCostSavingUnformatted: z.number().optional(),
      alternativeProducts: z
        .array(
          z.object({
            manufacturer: z.string(),
            sku: z.string(),
            imageUrl: z.string(),
            ekoScore: z.number(),
            price: z.string(),
            priceUnformatted: z.number(),
            url: z.string(),
            energyCost: z.string(),
            energyCostSaving: z.string(),
            compareRun: z.string(),
            compareBuy: z.string(),
            compareSaving: z.string(),
            isSponsored: z.boolean(),
            badge: z.string(),
            ekoGroupValue: z.number(),
            isPriceFromPartner: z.boolean(),
          }),
        )
        .optional(),
      numberOfAlternatives: z.number().optional(),
      medalRatingText: z.string().optional(),
      calculationData: z
        .object({
          operationalPowerConsumption: z.string(),
          energyCostByYear: z.record(z.string(), z.string()),
          totalEnergyCost: z.string(),
        })
        .optional(),
    }),
  ),
});
